export const esImagenValida = (url) => {
  return (
    typeof url === "string" &&
    url.trim() !== "" &&
    !url.includes("via.placeholder.com")
  );
};
